import { render, staticRenderFns } from "./periods_tab_content.vue?vue&type=template&id=712a9712&scoped=true&"
import script from "./periods_tab_content.vue?vue&type=script&lang=js&"
export * from "./periods_tab_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a9712",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fcustomers%2Felements%2Fperiods_tab_content.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./periods_tab_content.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports